import { UseCase } from './UseCase';
export class InstallNewStoolsOnTableUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return this.applicationServices.bar.installStoolForTable(event.tableId);
    }
}
